"use client";

import { c as _c } from "react/compiler-runtime";
import { FunctionComponent } from "react";
import ROUTES from "@app/routes";
import MindboxWidget from "@components/mindbox/widget";
import Link from "@components/navigation/link";
import { MainButton } from "@components/ui-kit/elements/buttons/main-button/main-button";
import { useLayout } from "@hooks/use-layout";
import NotFoundVisual from "./components/not-found-visual";
import styles from "./page-not-found.module.scss";
const PageNotFoundView: FunctionComponent = () => {
  const $ = _c(9);
  const {
    isDesktop
  } = useLayout();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.textBlock}><h1 className={styles.title}>Кажется, вышли за рамки</h1><p className={styles.description}>Так бывает — иногда страницы теряются. Каталог на месте и уже ждет тебя.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isDesktop ? "large" : "small";
  let t2;
  if ($[1] !== t1) {
    t2 = <div className={styles.content}>{t0}<div className={styles.actions}><MainButton className={styles.ctaButton} component={Link} href={ROUTES.CATALOG} label={"\u041A \u043F\u043E\u043A\u0443\u043F\u043A\u0430\u043C"} variant="primary" size={t1} /></div></div>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.visualSlot}><NotFoundVisual /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className={styles.card}>{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MindboxWidget widget="404" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <section className={styles.page}>{t4}{t5}</section>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default PageNotFoundView;